import { render } from "./concept-details.vue?vue&type=template&id=ab0a7b52"
import script from "./concept-details.vue?vue&type=script&lang=js"
export * from "./concept-details.vue?vue&type=script&lang=js"

import "./concept-details.vue?vue&type=style&index=0&id=ab0a7b52&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__